module.exports = __webpack_public_path__ + "img/pic1.95d5a6c5.jpg";